export const formFields = {
    grossAmount: 'grossAmount',
    nettAmount: 'nettAmount',
    dueDate: 'dueDate',
    saleDate: 'saleDate',
    issueDate: 'issueDate',
    createdDate: 'createdDate',
    costCategory: 'costCategory',
    exemptionReason: 'exemptionReason',
    customExemptionReason: 'customExemptionReason',
    name: 'name',
    description: 'description',
    additionalInformation: 'additionalInformation',
    date: 'date',
    userId: 'userId',
    email: 'email',
    password: 'password',
    passwordRepeat: 'passwordRepeat',
    oldPassword: 'oldPassword',
    firstName: 'firstName',
    lastName: 'lastName',
    phoneNumber: 'phoneNumber',
    regonNumber: 'regonNumber',
    institutionName: 'institutionName',
    rspoNumber: 'rspoNumber',
    institutionAffiliation: 'institutionAffiliation',
    institutionType: 'institutionType',
    street: 'street',
    zipCode: 'zipCode',
    city: 'city',
    peselNumber: 'peselNumber',
    birthPlace: 'birthPlace',
    birthDate: 'birthDate',
    group: 'group',
    accountingPeriodStartDate: 'accountingPeriodStartDate',
    accountingPeriodFinishDate: 'accountingPeriodFinishDate',
    declaredStayHoursFromTime: 'declaredStayHoursFromTime',
    declaredStayHoursToTime: 'declaredStayHoursToTime',
    sex: 'sex',
    diet: 'diet',
    diseases: 'diseases',
    allergens: 'allergens',
    socialNetworksImageSharingAgreementInstagram: 'socialNetworksImageSharingAgreementInstagram',
    socialNetworksImageSharingAgreementFacebook: 'socialNetworksImageSharingAgreementFacebook',
    socialNetworksImageSharingAgreementTikTok: 'socialNetworksImageSharingAgreementTikTok',
    socialNetworksImageSharingAgreementWebsite: 'socialNetworksImageSharingAgreementWebsite',
    guardians: 'guardians',
    parents: 'parents',
    employeeRole: 'employeeRole',
    groups: 'groups',
    teacherIds: 'teacherIds',
    roleTemplateName: 'roleTemplateName',
    childrenIds: 'childrenIds',
    childIds: 'childIds',
    childIdsToAdd: 'childIdsToAdd',
    idNumber: 'idNumber',
    bankAccountNumber: 'bankAccountNumber',
    helpForm: 'helpForm',
    childId: 'childId',
    attachments: 'attachments',
    inspectionSubject: 'inspectionSubject',
    inspectionIdNumber: 'inspectionIdNumber',
    supervisionForm: 'supervisionForm',
    supervisor: 'supervisor',
    teacherId: 'teacherId',
    roleId: 'roleId',
    subject: 'subject',
    childrenWithParentsIds: 'childrenWithParentsIds',
    monday: 'monday',
    tuesday: 'tuesday',
    wednesday: 'wednesday',
    thursday: 'thursday',
    friday: 'friday',
    saturday: 'saturday',
    sunday: 'sunday',
    entryTime: 'entryTime',
    exitTime: 'exitTime',
    timeFrom: 'timeFrom',
    timeTo: 'timeTo',
    coreCurriculums: 'coreCurriculums',
    sendConsentToParents: 'sendConsentToParents',
    journalId: 'journalId',
    repetition: 'repetition',
    contactWith: 'contactWith',
    startDate: 'startDate',
    finishDate: 'finishDate',
    dateFrom: 'dateFrom',
    dateTo: 'dateTo',
    billType: 'billType',
    basis: 'basis',
    therapyProgram: 'therapyProgram',
    notes: 'notes',
    progressAnalysis: 'progressAnalysis',
    childrenWork: 'childrenWork',
    notInLessonChildrenWork: 'notInLessonChildrenWork',
    lessonId: 'lessonId',
    educationalGuide: 'educationalGuide',
    educationalGuideTopic: 'educationalGuideTopic',
    selectFromTeacherList: 'selectFromTeacherList',
    withNotInLessonChildren: 'withNotInLessonChildren',
    joinDate: 'joinDate',
    leaveDate: 'leaveDate',
    content: 'content',
    receivers: 'receivers',
    notInLessonChildren: 'notInLessonChildren',
    homeworkDescription: 'homeworkDescription',
    homeworkDeadline: 'homeworkDeadline',
    mealPaymentType: 'mealPaymentType',
    absenceReportType: 'absenceReportType',
    mealProviderType: 'mealProviderType',
    absenceReportTime: 'absenceReportTime',
    cateringTransferName: 'cateringTransferName',
    cateringAddress: 'cateringAddress',
    cateringAccountNumber: 'cateringAccountNumber',
    selectMealsType: 'selectMealsType',
    methodOfCalcTheFee: 'methodOfCalcTheFee',
    tuition: 'tuition',
    isFreeHours: 'isFreeHours',
    charge: 'charge',
    freeHours: 'freeHours',
    isTimeInterval: 'isTimeInterval',
    discountType: 'discountType',
    discountTarget: 'discountTarget',
    applyType: 'applyType',
    amount: 'amount',
    endDate: 'endDate',
    courseId: 'courseId',
    teacherFullName: 'teacherFullName',
    freeFromSchool: 'freeFromSchool',
    type: 'type',
    payerType: 'payerType',
    journalName: 'journalName',
    childLimit: 'childLimit',
    topic: 'topic',
    userIds: 'userIds',
    absenceType: 'absenceType',
    paid: 'paid',
    paymentDueTime: 'paymentDueTime',
    workingDays: 'workingDays',
    sameAddressAsInstitution: 'sameAddressAsInstitution',
    address: 'address',
    free: 'free',
    settlementConfig: 'settlementConfig',
    paymentConfig: 'paymentConfig',
    lessonsType: 'lessonsType',
    settlementType: 'settlementType',
    transactionType: 'transactionType',
    paymentFormType: 'paymentFormType',
    childPaymentFormType: 'childPaymentFormType',
    childTransactionType: 'childTransactionType',
    costAllocationType: 'costAllocationType',
    costAllocationTarget: 'costAllocationTarget',
    paymentType: 'paymentType',
    additionalLessonPaymentType: 'additionalLessonPaymentType',
    status: 'status',
    organizationName: 'organizationName',
    recipientName: 'recipientName',
    freePeriodStart: 'freePeriodStart',
    freePeriodEnd: 'freePeriodEnd',
    price: 'price',
    freeHoursTimeFrame: 'freeHoursTimeFrame',
    freeHoursAmount: 'freeHoursAmount',
    foundationName: 'foundationName',
    invoiceNotes: 'invoiceNotes',
    balanceTargetType: 'balanceTargetType',
    refersTo: 'refersTo',
    specificAmount: 'specificAmount',
    percentageAmount: 'percentageAmount',
    nip: 'nip',
    periodStart: 'periodStart',
    enrollmentChildData: 'enrollmentChildData',
    enrollmentParentData: 'enrollmentParentData',
    enrollmentChildAddressData: 'enrollmentChildAddressData',
    additionalConditions: 'additionalConditions',
    paymentDeadline: 'paymentDeadline',
    notInLessonDescription: 'notInLessonDescription',
    lessonName: 'lessonName',
    topicName: 'topicName',
    nurseryRegistryNumber: 'nurseryRegistryNumber',
    stayVatRateType: 'stayVatRateType',
    mealVatRateType: 'mealVatRateType',
    vatRate: 'vatRate',
    vatReleaseReasonType: 'vatReleaseReasonType',
    customVatReleaseReason: 'customVatReleaseReason',
    starterKitVatRateType: 'starterKitVatRateType',
    mealVatReleaseReason: 'mealVatReleaseReason',
    mealCustomVatReleaseReason: 'mealCustomVatReleaseReason',
    stayVatReleaseReason: 'stayVatReleaseReason',
    stayCustomVatReleaseReason: 'stayCustomVatReleaseReason',
    starterKitVatReleaseReason: 'starterKitVatReleaseReason',
    starterKitCustomVatReleaseReason: 'starterKitCustomVatReleaseReason',
    vatRateType: 'vatRateType',
    pointOfSaleId: 'pointOfSaleId',
    secondKey: 'secondKey',
    clientId: 'clientId',
    clientSecret: 'clientSecret',
    subjectToInvoicing: 'subjectToInvoicing',
    stayTimeType: 'stayTimeType',
    stayFeeType: 'stayFeeType',
    timeRoundingUnitMinutes: 'timeRoundingUnitMinutes',
    costPerHour: 'costPerHour',
    flatMonthlyFee: 'flatMonthlyFee',
    refersToCourses: 'refersToCourses',
    dietFromDate: 'dietFromDate',
    monthlySettlementId: 'monthlySettlementId',
    correctionId: 'correctionId',
    sourceType: 'sourceType',
    splitType: 'splitType',
    additionalCostId: 'additionalCostId',
    invoiceRecipientId: 'invoiceRecipientId',
} as const;
